import { GiftCardIcon, deleteIconSVG } from "../../assets/SVGs/SVGs";
import SubInfo from "../admin/common/SubInfo";

type Props = { giftCard: any; setGiftCard: any };

const ListGiftCard = ({ giftCard, setGiftCard }: Props) => {
  console.log(giftCard);
  const removeGiftCardsItem = (index: number) => {
    const newGiftCards = giftCard.filter(
      (e: any, i: any) => e.itemable_id !== index
    );
    setGiftCard(newGiftCards);
  };
  return (
    <div className="flex flex-col items-center gap-4 text-sm">
      {giftCard.map((card: any) => (
        <div className="flex items-center w-full bg-[#FBFBFF] px-3 py-2">
          <div
            key={card.id} // Key should be unique for each child in the list
            className="flex flex-col items-center justify-between w-full gap-2 px-3 py-2 rounded-lg h-fit border border-[#EEF0FF]"
          >
            <div className="flex items-center justify-start w-full gap-2 font-semibold text-color-primary">
              {GiftCardIcon} <span>كارت هدايا #{card.itemable_id}</span>
            </div>
            <div className="flex items-center justify-between w-full">
              <SubInfo
                value={card.voucher_duration.split(" ")[0]}
                label="يوم"
              />
              <SubInfo value={card.price} label="ريال سعودي" />
            </div>
          </div>
          <div
            className="flex items-center h-full cursor-pointer w-fit"
            onClick={() => removeGiftCardsItem(card.itemable_id)}
            style={{ borderRight: "1px solid #9999A7" }}
          >
            <div className="p-3">{deleteIconSVG}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ListGiftCard;
